<div class="recipients-field-container" [attr.state]="getInputState()">
  <div class="recipients-type-caption">
    {{ recipientTypeCaption }}
  </div>
  <div class="recipients-list-container">
    <ul class="recipients-field-list">
      <ng-container *ngFor="let recipient of recipientsList">
        <li
          *ngIf="recipient.email !== null"
          class="recipients-list-element"
          [ngClass]="{
            highlight: isRecipientFlaggedForRemoval(recipient),
            invalidAddress: !testRecipient(recipient.email)
          }"
        >
          <sa-user-info-popup 
            [soti-tooltip]="
              recipient.displayName && recipient.displayName != recipient.email
                ? recipient.displayName + ' &#13;&#10; ' + recipient.email
                : recipient.email
            "
            placement="top"
            user-info="recipient"
            >{{ recipient.displayName || recipient.email }}</sa-user-info-popup
          >
          <div
            class="hd-icon hd-icon-close recipients-list-remove"
            (click)="removeRecipient(recipient)"
            [hidden]="isDisabled"
          ></div>
        </li>
      </ng-container>

      <li>
        <xs-search-and-pick
          class="recipients-search-and-pick"
          [excludeSearchParameter]="excludeSearchParameter"
          idField="userName"
          [placeholder]="getRecipientPlaceholder()"
          [showSearchAndCancelIcons]="false"
          [queryParameters]="userInfoQueryParameters"
          [minimumFilterLength]="2"
          [excludeList]="excludeIds"
          [queryFn]="userInfoSearchResource"
          [itemTemplate]="'reporterCardTemplate'"
          (onFocus)="toggleEditingState($event)"
          (onPick)="addRecipient($event)"
          (onEntered)="addCustomReporterAsRecipient($event)"
          (onKeyPress)="keyPressed($event)"
          (onPaste)="handlePaste($event)"
          (onSubmit)="addOrCreateRecipient($event)"
        >
        </xs-search-and-pick>
      </li>
      <li class="loading-spinner-list-item" [ngClass]="{ loading: isLoading() }">
        <span class="loading-spinner-icon fa fa-circle-o-notch fa-spin"></span>
      </li>
    </ul>
  </div>
</div>
